module.exports = __webpack_public_path__ + "img/W.1a5bc394.png";